/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import bgCardNoBorder from "../../assets/bgCardNoBorder.png";
import useWindowSize from "../hooks/WindowResizer";

const GuestReportCard = ({
  heading,
  subHeading,
  linkTxt,
  linkUrl,
  isActive,
  onLinkClick,
  isCompleted,
  isChecked,
}) => {
  console.log("isActive", isActive);

  console.log("isCompleted", isCompleted);

  const isMobileView = useWindowSize();

  const isCompletedOnly = isChecked && !isActive;

  const paddingH = isMobileView ? "17px" : "40px";

  const containerStyles = {
    border: isActive ? "2px solid #28a382" : "none",
    // padding: isActive ? "40px" : "none",
    padding: isActive ? paddingH : "none",
    backgroundImage: isCompletedOnly ? `url(${bgCardNoBorder})` : "none",

    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  };

  const headingColor = isCompletedOnly ? "white" : "#28A382";
  const subHeadingColor = isCompletedOnly ? "white" : "#707070";
  const linkColor = "#28A382";
  const displayLink = isCompleted ? "inline" : "none";

  return (
    <div className="reportCard-container" style={containerStyles}>
      <div className="reportCard-content">
        <h4 style={{ color: headingColor }}>{heading}</h4>
        <p style={{ color: subHeadingColor }}>{subHeading}</p>
      </div>
      {linkTxt && (
        <div className="reportCard-link">
          <a
            onClick={(e) => {
              e.preventDefault();
              if (onLinkClick) onLinkClick();
            }}
            href="#"
            style={{
              color: linkColor,
              cursor: "pointer",
              display: displayLink,
            }}
          >
            {linkTxt}
          </a>
        </div>
      )}
    </div>
  );
};

export default GuestReportCard;
